import { useNavigate } from "react-router-dom";

export const ButtonExploreArt = ({
  point,
  className,
}: {
  point: string;
  className?: string;
}) => {
  const navigate = useNavigate();
  const handleRedirectAllProducts = () => {
    navigate(point);
  };

  return (
    <button
      className={`px-6 py-2 bg-red-600 text-white hover:bg-red-700 font-bold border-b-4 border-red-900 hover:border-red-500 transition duration-300  rounded cursor-pointer  ${className}`}
      onClick={handleRedirectAllProducts}
    >
      Saiba mais
    </button>
  );
};
